// Tenant IDs returned by svc-auth /me, distinct from the brand IDs in constants/brands.
export const LUXURY_ESCAPES_TENANT = 'lux'
export const BUSINESS_TRAVELLER_TENANT = 'lebusinesstraveller'
